<template>
  <SysDialog
    v-model="dialog_ativo"
    titulo="Aplicar Coberturas"
    :largura="400"
    txt-botao="sim, aplicar"
    @click:primary="aplicarCoberturas"
  >
    <template #ativador>
      <slot name="ativador" :callback="() => dialog_ativo = ! dialog_ativo">
        <v-btn small :class="content_class" color="primary" @click="dialog_ativo = true">
          <v-icon :size="18">mdi-playlist-check</v-icon>
          aplicar
        </v-btn>
      </slot>
    </template>

    <p class="ma-0 mt-n1 text-justify">
      Deseja realmente aplicar as coberturas?
    </p>
  </SysDialog>
</template>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {ref} from "vue";
import store from "@/store";
import * as req from "@/api/compras/CoberturaEsegPorLocalidade";
import {logout} from "@/helpers";

const props = defineProps({
  content_class: String,
  coberturas: Array,
});

const emit = defineEmits(['coberturas-aplicadas'])

const dialog_ativo = ref(false);

function aplicarCoberturas() {
  const parametros = {
    coberturas: props.coberturas.map(item => ({pqr: item.pqr, xyz: item.xyz}))
  };

  store.dispatch('loading/addRequisicao',
    req.aplicarCoberturas(parametros)
      .then(() => {
        dialog_ativo.value = false;
        emit('coberturas-aplicadas', {});
      })
      .catch(logout)
  );
}
</script>

<style scoped>

</style>
